let toggles: { [key: string]: boolean } = {};

/**
 * In-Browser function to read a given GET parameter and use its value as comma separated feature flags.
 */
export function setTogglesFromBrowserGETParameter(parameterName = "toggle") {
    if (typeof location === "undefined" || !location.search) {
        return;
    }

    const flags = location.search
        .split("?")[1]
        .split("&")
        .filter(v => !!v)
        .map((combination) => combination.split("="))
        .find(([key]) => key === parameterName);

    if (flags) {
        /* tslint:disable-next-line */
        console.log("Feature toggles set:", flags[1].split(","));
        setManyToggles(flags[1].split(","));
    }
}

/**
 * Enable many feature toggles with one call.
 */
export function setManyToggles(featureNameArray: string[]) {
    featureNameArray.forEach((featureName) => toggles[featureName] = true);
}

/**
 * Enables disables the feature toggle with the given name.
 */
export function setFeatureEnabled(featureName: string, isEnabled: boolean = true) {
    toggles[featureName] = isEnabled;
    return Object.assign({}, toggles);
}

/**
 * Returns true/false whether the feature with the given name should be enabled.
 */
export function featureIsEnabled(featureName: string): boolean {
    return toggles[featureName] || false;
}

if (typeof window !== "undefined") {
    // @ts-ignore
    window.setFeatureEnabled = setFeatureEnabled;
}
